import { Button } from 'antd';
import styled, { keyframes } from 'styled-components';

const paleGreen = '#bbc895';
const chartSettingsViolet = '#8a3dff';

const slideIn = keyframes` 
0% {
  left: -100%;
  width: 0px; 
}
100% { 
  left: 0;
  width: 350px; 
}`;

export const ChartSidebarContainer = styled.div`
  background: #fff;
  height: calc(100% - 70px);
  top: 10px;
  position: relative;
  z-index: 99;
  animation: ${props => (props.display ? slideIn : 'none')} 0.5s ease-in-out;
  box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%), 0 4px 25px 0 rgb(0 0 0 / 12%),
    0 8px 10px -5px rgb(0 0 0 / 20%);
  width: 350px;
  min-width: 350px;
  overflow-y: auto;
`;

export const ChartTitle = styled.h3`
  font-weight: bold;
  color: #0e1318;
  padding: 0 30px;
  font-size: 16px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChartTabsContainer = styled.div`
  .ant-tabs-bar {
    border-bottom: none;
    .ant-tabs-nav {
      width: 100%;
      > div {
        display: flex;
        > div.ant-tabs-tab {
          flex-basis: 50%;
          text-align: center;
          :hover {
            color: inherit;
          }
        }
        > div.ant-tabs-tab-active {
          color: inherit;
          font-weight: bold;
        }
      }
      .ant-tabs-ink-bar {
        background-color: ${chartSettingsViolet};
      }
    }
  }
`;

export const ChartSettings = styled.div`
  margin: 0px 10px;
`;

export const ChartImageView = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

export const ChartPreviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChartDataTab = styled.div`
  > label#dynamic-chart-switch {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    > span {
      width: 200px;
      font-size: 16px;
    }
    > .ant-switch-checked {
      background-color: ${paleGreen} !important;
    }
  }
  > button.ant-btn-link {
    padding: 0px;
    > span {
      vertical-align: bottom;
      margin-left: 4px;
    }
  }

  > div {
    display: flex;
    flex-direction: column;
    > label,
    > .label {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > span {
        width: 100px;
      }
      > .ant-select {
        width: 100%;
      }
    }
  }
  label,
  .label {
    padding: 12px 16px;
    padding-right: 40px;
  }
  .ant-table-wrapper {
    table {
      border-radius: 0px;
      tbody {
        tr {
          td {
            :not(:first-of-type) {
              padding: 0px !important;
              background-color: #fff !important;
            }
          }
        }
      }
      thead {
        tr {
          th {
            border-top-right-radius: 0px !important;
            border-top-left-radius: 0px !important;
          }
        }
      }
    }
  }
`;

export const CollapseContainer = styled.div`
  .ant-collapse-icon-position-right {
    .ant-collapse-item {
      .ant-collapse-header {
        > div {
          text-transform: uppercase;
          font-size: 16px;
          > .anticon {
            margin-right: 12px;
          }
          > span {
            vertical-align: text-bottom;
            .anticon {
              margin-left: 24px;
            }
          }
        }
      }
    }
  }
`;

export const ChartGeneralSettings = styled.div`
  display: flex;
  flex-direction: column;
  > label {
    :first-of-type#pie-format-values-at {
      > div {
        font-weight: bold;
        margin-bottom: 12px;
      }
      > .ant-radio-group {
        display: flex;
        justify-content: space-between;
        > label.ant-radio-button-wrapper {
          border-radius: 4px;
          width: 100%;
          :first-of-type {
            margin-right: 12px;
          }
          &.ant-radio-button-wrapper-checked {
            border: 2px solid #d9d9d9;
            border-color: ${chartSettingsViolet};
            color: #000000;
            box-shadow: none;
          }
          :hover {
            color: #000000;
          }
        }
      }
    }
    :first-of-type#bar-format-values {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > span {
        width: 100%;
      }
      > div,
      > span {
        display: flex;
        gap: 5px;
        align-items: center;
      }
    }
    :not(:first-of-type) {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .ant-switch-checked {
        background-color: ${paleGreen} !important;
      }
      > span {
        display: flex;
        gap: 5px;
        align-items: center;
      }
    }
    :last-of-type,
    &.width-100 {
      > span,
      > div {
        width: 100%;
      }
      > span {
        align-self: center;
      }
    }
  }
`;

export const ChartFontsizeSettings = styled.div`
  > label {
    display: flex;
    align-items: center;

    > span {
      flex-basis: 30%;
    }
    :not(:last-of-type) {
      margin-bottom: 20px;
    }
  }
`;

export const FontstyleComboboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-basis: 70%;
`;

export const ChartTypeSettings = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 320px;
  img {
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    -ms-user-drag: none;
  }
`;

export const ChartTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => (props.active ? paleGreen : '')};
  border-radius: 10px;
  width: 140px;
  margin-bottom: 10px;
  justify-content: end;
  cursor: pointer;
  :nth-of-type(odd) {
    margin-right: 10px;
  }
  > img {
    width: 70%;
    height: 60%;
  }
  > div {
    margin-top: 5px;
    margin-bottom: 10px;
  }
`;

export const ChartStylesSettings = styled.div`
  > .ant-radio-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    > label.ant-radio-button-wrapper {
      border-radius: 4px;
      min-width: 75%;
      margin-bottom: 16px;
      text-align: center;
      &.ant-radio-button-wrapper-checked {
        border: 2px solid #d9d9d9;
        border-color: ${chartSettingsViolet};
        color: #000000;
        box-shadow: none;
      }
      :hover {
        color: #000000;
      }
    }
  }
`;

export const SizeButton = styled(Button)`
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: ${props => (props.width ? props.width + 'px !important' : `auto !important`)};
  border: 1px solid #d9d9d9 !important;
  height: 32px !important;
  background: ${props => props.comboBox && '#ffffff !important'};
  padding: 0 10px !important;
  margin-right: ${props => props.comboBox && !props.isMinus && '15px'};
  z-index: 10;
  border-radius: 0 !important;
  margin-left: 0px !important;
  i {
    padding-right: ${props => (props.comboBox ? '0' : '12px')};
    margin-top: ${props => (props.comboBox ? '0' : '-29px')};
    color: #000;
  }
  input {
    width: 50px;
    height: 99%;
    text-align: center;
    border-radius: unset;
    border-color: transparent;
    margin: 0px -15px;
    z-index: 100;
  }
  span {
    width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #fff;
  }
`;

export const SizeContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 350px;
  width: 130px;
  li {
    cursor: pointer;
    padding: 7px 20px;
    &:hover,
    &:focus {
      background-color: rgba(14, 19, 24, 0.07) !important;
    }
  }
`;

export const EditableInputContainer = styled.div`
  width: 100%;
  height: 40px;
  > div {
    width: fit-content;
    height: inherit;
    z-index: 2;
    position: absolute;
  }
  > input {
    border-radius: 0px;
    padding: 8px;
    border: none;
    height: 40px;
    :focus {
      border: 1px solid #40a9ff;
    }
  }
`;

export const ColorCellHorPopover = styled.div`
  .ant-btn {
    padding: 0px 6px;
    .anticon {
      font-size: 20px;
    }
  }
`;

export const ColorCellVerPopover = styled.div`
  ul {
    display: flex;
    flex-direction: column;
    width: 200px;
    li {
      cursor: pointer;
      font-size: 16px;
      padding: 8px 8px;
      :hover {
        background-color: #e1e4e7;
      }
    }
  }
`;

export const ChartColorPickerSection = styled.div`
  display: flex;
  gap: 10px;
  margin-left: 20px;
  > i.anticon-plus {
    color: white;
    cursor: pointer;
  }
`;

export const ChartColorPickerContainer = styled.span`
  height: 16px;
  width: 16px;
  cursor: pointer;
  > div {
    position: absolute;
    z-index: 11;
    margin-top: 20px;
    margin-left: -100px;
  }
`;

export const EditableTable = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .ant-table-wrapper {
    width: 92%;
    .ant-table-body {
      .ant-table-thead {
        th {
          padding: 0px !important;
          .ant-table-header-column {
            .ant-input {
              background: transparent;
            }
          }
        }
      }
    }
  }
`;
